import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import { TextField, Menu, MenuItem } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker, KeyboardTimePicker, DatePicker } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import "moment/locale/zh-tw"// import { es, ru } from "@date-io/locale";
import moment from "moment";
import Grid from '@material-ui/core/Grid';
import CakeIcon from '@material-ui/icons/Cake';
import CakeOutlinedIcon from '@material-ui/icons/CakeOutlined';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Brightness2Icon from "@material-ui/icons/Brightness2";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import useSound from 'use-sound';
import switchlight from '../../sounds/switchlight.wav';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../reducers/app";
import { indigo, teal, deepPurple } from '@material-ui/core/colors'
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import _ from "lodash";
import { GTranslate } from '@material-ui/icons';
import { FormattedMessage } from "react-intl";
import { injectIntl, intlShape, useIntl } from 'react-intl';
import { useGmailListItemStyles } from '@mui-treasury/styles/listItem/gmail';
//設定語系
// moment.locale("e");

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    '&:first-child ': {
      padding: 0,
    }
  },
  appBar: {
    position: 'relative',
    backgroundColor: indigo[500],
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  button: {
    borderRight: "3px solid transparent",
    "&:hover": {
      borderRightColor: "blue",
      borderRight: "3px solid",
    },
    "&:focus": {
      borderRightColor: "blue",
      borderRight: "3px solid",
    }
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {
  const { open, setOpen, logo, settingObj, handleDateChange, handleTxtChange, formRef, data, handleSubmit, BackDropColor } = props;
  const classes = useStyles();
  const classes3 = useGmailListItemStyles({ color: teal[900] });
  const handleClickOpen = () => {
    setOpen(true);
  };
  const { dark } = useSelector(state => ({
    dark: state.app.dark,
  }));
  const { app } = useSelector(state => ({
    app: state.app,
  }));
  const handleClose = () => {
    setOpen(false);
  };
  const icon = !dark ? <Brightness7Icon style={{ color: "white" }} /> : <Brightness2Icon />;
  const [playActive] = useSound(
    switchlight,
    { volume: 0.5 }
  );
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const TranslateOpen = Boolean(anchorEl);


  const handleTranslateClose = () => {
    setAnchorEl(null);
  };
  const handleI18nChange = (event, lang) => {
    moment.locale(lang);
    dispatch(actions.LANG_SET(lang));
    setAnchorEl(null);
    playActive();
  };
  const intl = useIntl();


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        BackdropProps={{
          // open: false
          // backgroundColor: "transparent",
          invisible: true,
        }}
        style={_.isNil(BackDropColor) ? { pointerEvents: 'none' } : null} //可以跟後面互動
        PaperProps={{ style: { pointerEvents: 'auto', overflowX: "hidden" }, className: classes.shrinkTitle }} //可以跟後面互動
      >
        <DialogTitle className={classes.root}>
          <AppBar className={classes.appBar} >
            <Toolbar style={{ width: "100%" }}>
              <Typography variant="h6" className={classes.title} style={{ flex: 1 }}>
                <img src={logo} style={{ pointerEvents: "none", paddingTop: "10px" }} />
              </Typography>

              {/* <IconButton size="small" onMouseDown={() => playActive()}
                onClick={(e) => {
                  dispatch(actions.THEME_SET({ theme: !dark }))
                }}
              >
                {icon}
              </IconButton> */}
              <DarkModeSwitch
                style={{ marginBottom: '2rem', float: "right" }}
                checked={dark}
                onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                onMouseDown={(e) => {
                  e.preventDefault();
                  // e.stopPropagation();
                  playActive()
                }}
                // style={{ width: "50px" }}
                size={20} />
            </Toolbar>
          </AppBar>

        </DialogTitle>
        <form onSubmit={handleSubmit} ref={formRef} style={{ display: "flex", flexDirection: "column", overflowY: "auto" }} noValidate>
          <MuiPickersUtilsProvider utils={MomentUtils} locale={app.i18n.locale}>
            <DialogContent dividers={true} style={{ overflowX: "hidden" }} className={classes.root}>
              <GridContainer>
                <List style={{ width: "100%" }}>
                  {settingObj.map((item, key) => {
                    if (item.type === "date") {
                      return (
                        <GridItem xs={item.xs} sm={item.sm} md={item.md} lg={item.lg}>
                          <ListItem button className={classes.button}>
                            <Grid container spacing={0} alignItems="flex-end">
                              <Grid item xs={2}>
                                <CakeOutlinedIcon />
                              </Grid>
                              <Grid item xs={10}>
                                <KeyboardDatePicker
                                  format="YYYY/MM/DD"
                                  // inputVariant="filled"
                                  key={key}
                                  views={["year", "month", "date"]}
                                  fullWidth
                                  autoOk
                                  // variant="inline"
                                  placeholder={item.placeholder || "2000/01/01"}
                                  autoComplete="off"
                                  clearable
                                  type="datetime"
                                  inputProps={{
                                    // ...prop //像是minLength、pattern
                                    pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                  }}
                                  name={item.name}
                                  required={item.required || false}
                                  error={item.error || false}
                                  helperText={item.error ? intl.formatMessage({ id: item.helperText }) : null}
                                  // todayLabel={<TodayIcon />}
                                  // showTodayButton
                                  minDate={item.minDate || new Date("1900-01-01")}
                                  maxDate={item.maxDate || new Date("2100-01-01")}
                                  openTo={item.openTo || ""}
                                  disableFuture={item.disableFuture || false}
                                  clearLabel={<FormattedMessage id={"app.Clear"} key={"app.Clear"} />}
                                  cancelLabel={"X"}
                                  label={<FormattedMessage id={item.name} key={item.name} />}
                                  // value={item.value || null}
                                  // inputValue={item.value}
                                  onChange={(event, value) =>
                                    handleDateChange(item.name, event, value)
                                  }
                                  value={data[item.name] || null}
                                  style={{ imeMode: "disabled" }}
                                />
                              </Grid>
                            </Grid>

                          </ListItem>
                        </GridItem>
                      )
                    } else {
                      return (
                        <GridItem xs={item.xs} sm={item.sm} md={item.md} lg={item.lg}>
                          <ListItem button className={classes.button}>
                            <Grid container spacing={0} alignItems="flex-end">
                              <Grid item xs={2} >{
                                key === 0 ? <AccountCircle /> : <CreditCardIcon />
                              }
                              </Grid>
                              <Grid item xs={10}>
                                <TextField
                                  // variant="filled"
                                  key={key}
                                  helperText={item.error ? intl.formatMessage({ id: item.helperText }) : null}
                                  autoComplete="off"
                                  error={item.error || false}
                                  required={item.required || false}
                                  fullWidth
                                  name={item.name}
                                  label={<FormattedMessage id={item.name} key={item.name} />}
                                  placeholder={item.placeholder || ""}
                                  value={_.isEmpty(data[item.name]) ? "" : data[item.name]}
                                  onChange={handleTxtChange}
                                  inputProps={{
                                    ...item //像是minLength、pattern
                                    // pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                  }} />
                              </Grid>
                            </Grid>

                          </ListItem>
                        </GridItem>
                      )
                    }

                  })}
                </List>
              </GridContainer>
            </DialogContent>
            <DialogActions>
              <Button size="small" type="submit" color="primary" variant="contained" style={{ width: "95%", cursor: 'pointer', backgroundColor: indigo[500] }} onClick={handleSubmit}><FormattedMessage id={"app.LoginButton"} key={"app.LoginButton"} /></Button>
              <Button size="small" color="primary" variant="contained" style={{ cursor: 'pointer', backgroundColor: teal[700] }} onClick={e => { setAnchorEl(e.currentTarget); }}>
                <GTranslate />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={TranslateOpen}
                onClose={handleTranslateClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
                value={app.i18n.locale}
              >
                <MenuItem classes={classes3} style={{ color: app.i18n.locale === "zh-tw" ? "white" : "" }} selected={app.i18n.locale === "zh-tw"} value="zh-tw" onClick={(e) => handleI18nChange(e, "zh-tw")}>繁體中文</MenuItem>
                <MenuItem classes={classes3} style={{ color: app.i18n.locale === "en" ? "white" : "" }} selected={app.i18n.locale === "en"} value="en" onClick={(e) => handleI18nChange(e, "en")}>English</MenuItem>
              </Menu>
            </DialogActions>
          </MuiPickersUtilsProvider>
        </form>
      </Dialog>
    </>
  );
}